// extracted by mini-css-extract-plugin
export default {"headerSolicitudes":"TablaProducto_headerSolicitudes__H+864","text_danger":"TablaProducto_text_danger__zoHK9","text_success":"TablaProducto_text_success__-+a8I"};